export const ZIndex = {
  hide: -1,
  base: 0,
  raised: 1,
  sticky: 2,
  header: 3,
  sidebar: 4,
  modal: 1000,
  popover: 1030,
  dropdown: 1050,
  tooltip: 1070,
} as const;

export type ZIndexTokenType = keyof typeof ZIndex;
